// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180734/js/" + chunkId + "." + {"44":"baf5f6cf","225":"2d8bfcb7","481":"de184c21","486":"7f0e7f7e","770":"1d90cd80"}[chunkId] + ".0.5645854317920621.chunk.js";
};